/**
 * @generated SignedSource<<fbffdb21c8104533c2e88e3320ccc0c1>>
 * @relayHash fcfc2d9b0f804b2483ddcf7145a681dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 724c9c43713dcdc68803fcd115dbe1babe7be82cef5185aa9a634678ac1544a4

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type CommentResolveCommentMutation$variables = {
  cloudId: string;
  commentIds: ReadonlyArray<string | null | undefined>;
};
export type CommentResolveCommentMutation$data = {
  readonly confluence_resolveComments: {
    readonly commentResolutionStates: ReadonlyArray<{
      readonly commentId: string;
      readonly resolveProperties: {
        readonly resolvedFriendlyDate: string | null | undefined;
        readonly resolvedTime: AGG$Long | null | undefined;
        readonly resolvedUser: string | null | undefined;
      } | null | undefined;
      readonly status: boolean | null | undefined;
    } | null | undefined> | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly __typename: "ResolveCommentsMutationErrorExtension";
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type CommentResolveCommentMutation = {
  response: CommentResolveCommentMutation$data;
  variables: CommentResolveCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentIds"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "commentIds",
    "variableName": "commentIds"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "concreteType": "ConfluenceCommentResolutionState",
  "kind": "LinkedField",
  "name": "commentResolutionStates",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "commentId"
    },
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "resolveProperties",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "resolvedTime"
        },
        {
          "kind": "ScalarField",
          "name": "resolvedUser"
        },
        {
          "kind": "ScalarField",
          "name": "resolvedFriendlyDate"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "message"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "errorType"
    },
    {
      "kind": "ScalarField",
      "name": "statusCode"
    }
  ],
  "type": "ResolveCommentsMutationErrorExtension"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CommentResolveCommentMutation",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "ConfluenceResolveCommentsPayload",
        "kind": "LinkedField",
        "name": "confluence_resolveComments",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CommentResolveCommentMutation",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "ConfluenceResolveCommentsPayload",
        "kind": "LinkedField",
        "name": "confluence_resolveComments",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "fcfc2d9b0f804b2483ddcf7145a681dc",
    "id": "724c9c43713dcdc68803fcd115dbe1babe7be82cef5185aa9a634678ac1544a4",
    "metadata": {},
    "name": "CommentResolveCommentMutation",
    "operationKind": "mutation",
    "text": "mutation CommentResolveCommentMutation($commentIds:[ID]!,$cloudId:ID!){confluence_resolveComments(commentIds:$commentIds,cloudId:$cloudId){success,commentResolutionStates{commentId,resolveProperties{resolvedTime,resolvedUser,resolvedFriendlyDate},status},errors{message,extensions{...on ResolveCommentsMutationErrorExtension{errorType,statusCode},__typename,...on BulkMutationErrorExtension{id}}}}}"
  }
};
})();

(node as any).hash = "a1e79d6cdf36db4379af2bb6df78c060";

export default node;
